export default __webpack_public_path__ + "static/media/proj-gurupharma.e3c9dcf3.jpg";